const AUTH_TYPES = {
  RESET_STATE: "RESET_STATE",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  UPDATE_INFO:'UPDATE_INFO',
  UPDATE_PROFILE:'UPDATE_PROFILE'
};

export default AUTH_TYPES;
